import { IconLoader2, type IconProps } from "@tabler/icons-react";
import { cn } from "../utils";

function LoadingSpinner({ className, ...props }: IconProps) {
  return (
    <>
      <svg width="0" height="0" className="absolute">
        <defs>
          <linearGradient
            id="voiceover-loader-gradient"
            x1="0%"
            y1="0%"
            x2="100%"
            y2="0%"
          >
            <stop offset="0%" stopColor="#f98c5e" />
            <stop offset="100%" stopColor="#f66c97" />
          </linearGradient>
        </defs>
      </svg>
      <IconLoader2
        size={20}
        {...props}
        className={cn("animate-spin", className)}
        color="url(#voiceover-loader-gradient)"
      />
    </>
  );
}

export default LoadingSpinner;
